import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["input", "listItem", "icon"];

  select(event) {
    if (event.target.classList.contains('js-mobile-check-icon')) {
      return false;
    }

    this.inputTarget.value = event.currentTarget.dataset["id"];

    this._updateActiveItem(event.currentTarget);
  }

  _updateActiveItem(listItem) {
    this._removeFontColorMobile();
    this._setFontColorMobile(listItem);
    this._updateIconPlacement(listItem);
  }

  _removeFontColorMobile() {
    this.listItemTargets.forEach(item => {
      item.classList.remove('font-bold', 'text-primary-700');
    })
  }

  _setFontColorMobile(target) {
    target.classList.add('font-bold', 'text-primary-700');
  }

  _updateIconPlacement(listItem) {
    let mobileIcon = this.iconTarget.cloneNode(true);

    this.iconTarget.remove();
    listItem.appendChild(mobileIcon);
  }
}
